import './App.css';
import Player from './components/player';

function App() {
  return (
    <div className="App">
     <Player url="/videos/video.mp4"/>
    </div>
  );
}

export default App;
